<template>
  <div class="ce">
    <div class="ce-toolbar">
      <button
        v-for="b in buttons"
        :key="b.cmd + (b.arg || '')"
        type="button"
        class="ce-btn"
        :title="b.title"
        :disabled="disabled"
        @mousedown.prevent="run(b.cmd, b.arg)"
      >
        <v-icon size="18">{{ b.icon }}</v-icon>
      </button>
    </div>
    <div
      ref="area"
      class="ce-area"
      :contenteditable="!disabled"
      @input="emitValue"
      @blur="emitValue"
    ></div>
  </div>
</template>

<script>
// Editor de texto enriquecido mínimo (contenteditable) para el contrato del
// cliente. El backend sanea el HTML antes de guardarlo y de armar el PDF.
export default {
  name: "ContractEditor",
  props: {
    modelValue: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      buttons: [
        { cmd: "bold", icon: "mdi-format-bold", title: "Negrita" },
        { cmd: "italic", icon: "mdi-format-italic", title: "Cursiva" },
        { cmd: "underline", icon: "mdi-format-underline", title: "Subrayado" },
        { cmd: "formatBlock", arg: "h2", icon: "mdi-format-header-2", title: "Título" },
        { cmd: "formatBlock", arg: "h3", icon: "mdi-format-header-3", title: "Subtítulo" },
        { cmd: "formatBlock", arg: "p", icon: "mdi-format-paragraph", title: "Párrafo" },
        { cmd: "insertUnorderedList", icon: "mdi-format-list-bulleted", title: "Lista" },
        { cmd: "insertOrderedList", icon: "mdi-format-list-numbered", title: "Lista numerada" },
        { cmd: "justifyLeft", icon: "mdi-format-align-left", title: "Alinear a la izquierda" },
        { cmd: "justifyCenter", icon: "mdi-format-align-center", title: "Centrar" },
        { cmd: "justifyFull", icon: "mdi-format-align-justify", title: "Justificar" },
        { cmd: "undo", icon: "mdi-undo", title: "Deshacer" },
        { cmd: "redo", icon: "mdi-redo", title: "Rehacer" },
      ],
    };
  },
  watch: {
    // Sólo se reescribe el contenido cuando cambia desde afuera (cargar,
    // restaurar): reescribirlo en cada tecla movería el cursor al inicio.
    modelValue(value) {
      const area = this.$refs.area;
      if (area && value !== area.innerHTML) area.innerHTML = value || "";
    },
  },
  mounted() {
    this.$refs.area.innerHTML = this.modelValue || "";
    try {
      document.execCommand("styleWithCSS", false, true);
    } catch (e) {
      // Algunos navegadores no lo soportan; el formato igual funciona.
    }
  },
  methods: {
    run(cmd, arg) {
      if (this.disabled) return;
      this.$refs.area.focus();
      document.execCommand(cmd, false, arg || null);
      this.emitValue();
    },
    emitValue() {
      this.$emit("update:modelValue", this.$refs.area.innerHTML);
    },
  },
};
</script>

<style scoped>
.ce {
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  background: #fff;
}
.ce-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 6px;
  border-bottom: 1px solid #e3e3e3;
  background: #f6f6f6;
  border-radius: 8px 8px 0 0;
}
.ce-btn {
  width: 32px;
  height: 30px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #333;
  cursor: pointer;
}
.ce-btn:hover:not(:disabled) {
  background: #e4e4e4;
}
.ce-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.ce-area {
  min-height: 320px;
  max-height: 520px;
  overflow-y: auto;
  padding: 16px 18px;
  color: #222;
  font-size: 13px;
  line-height: 1.7;
  outline: none;
}
.ce-area :deep(p) {
  margin: 0 0 12px;
}
.ce-area :deep(h2),
.ce-area :deep(h3) {
  margin: 6px 0 10px;
  color: #1a1a1a;
}
.ce-area :deep(ul),
.ce-area :deep(ol) {
  padding-left: 22px;
  margin-bottom: 12px;
}
</style>
